// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* InsightIQ Chat Integration Component Styles */

/* Main container for InsightIQ chat component */
.chat-widget-container {
    /* Ensure proper positioning and isolation for InsightIQ chat component */
    position: relative;
    z-index: 1;
}

/* InsightIQ chat web component specific styling */
insight-iq-chat {
    /* Ensure component has proper isolation while preserving functionality */
    position: fixed;
    z-index: 9999;
    /* Ensure component can capture focus and input events */
    pointer-events: auto !important;
}

/* Minimal styling to support proper InsightIQ chat functionality */
insight-iq-chat input,
insight-iq-chat textarea {
    /* Ensure InsightIQ chat inputs work with our app's font family */
    font-family: Gibson-Regular, sans-serif;
}

/* InsightIQ chat loading state styles */
.chat-widget-loading {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
    padding: 10px 15px;
    border-radius: 8px;
    font-size: 12px;
    font-family: Gibson-Regular, sans-serif;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* InsightIQ chat error state styles */
.chat-widget-error {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
    padding: 10px 15px;
    border-radius: 8px;
    font-size: 12px;
    font-family: Gibson-Regular, sans-serif;
    background-color: rgba(220, 53, 69, 0.9);
    color: white;
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

/* Ensure proper keyboard navigation within InsightIQ chat */
insight-iq-chat:focus-within {
    outline: none;
}

/* Loading animation for better UX */
.chat-widget-loading::after {
    content: '...';
    animation: chat-loading-dots 1.5s infinite;
}

@keyframes chat-loading-dots {
    0%, 20% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/InsightIQChat/style.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD,gDAAgD;AAChD;IACI,yEAAyE;IACzE,kBAAkB;IAClB,UAAU;AACd;;AAEA,kDAAkD;AAClD;IACI,yEAAyE;IACzE,eAAe;IACf,aAAa;IACb,wDAAwD;IACxD,+BAA+B;AACnC;;AAEA,mEAAmE;AACnE;;IAEI,iEAAiE;IACjE,uCAAuC;AAC3C;;AAEA,wCAAwC;AACxC;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uCAAuC;IACvC,oCAAoC;IACpC,YAAY;IACZ,yCAAyC;AAC7C;;AAEA,sCAAsC;AACtC;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uCAAuC;IACvC,wCAAwC;IACxC,YAAY;IACZ,6CAA6C;AACjD;;AAEA,4DAA4D;AAC5D;IACI,aAAa;AACjB;;AAEA,oCAAoC;AACpC;IACI,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":["/* InsightIQ Chat Integration Component Styles */\n\n/* Main container for InsightIQ chat component */\n.chat-widget-container {\n    /* Ensure proper positioning and isolation for InsightIQ chat component */\n    position: relative;\n    z-index: 1;\n}\n\n/* InsightIQ chat web component specific styling */\ninsight-iq-chat {\n    /* Ensure component has proper isolation while preserving functionality */\n    position: fixed;\n    z-index: 9999;\n    /* Ensure component can capture focus and input events */\n    pointer-events: auto !important;\n}\n\n/* Minimal styling to support proper InsightIQ chat functionality */\ninsight-iq-chat input,\ninsight-iq-chat textarea {\n    /* Ensure InsightIQ chat inputs work with our app's font family */\n    font-family: Gibson-Regular, sans-serif;\n}\n\n/* InsightIQ chat loading state styles */\n.chat-widget-loading {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 9999;\n    padding: 10px 15px;\n    border-radius: 8px;\n    font-size: 12px;\n    font-family: Gibson-Regular, sans-serif;\n    background-color: rgba(0, 0, 0, 0.8);\n    color: white;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n/* InsightIQ chat error state styles */\n.chat-widget-error {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 9999;\n    padding: 10px 15px;\n    border-radius: 8px;\n    font-size: 12px;\n    font-family: Gibson-Regular, sans-serif;\n    background-color: rgba(220, 53, 69, 0.9);\n    color: white;\n    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\n}\n\n/* Ensure proper keyboard navigation within InsightIQ chat */\ninsight-iq-chat:focus-within {\n    outline: none;\n}\n\n/* Loading animation for better UX */\n.chat-widget-loading::after {\n    content: '...';\n    animation: chat-loading-dots 1.5s infinite;\n}\n\n@keyframes chat-loading-dots {\n    0%, 20% {\n        opacity: 0;\n    }\n    50% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
